import { render, staticRenderFns } from "./PLUD.vue?vue&type=template&id=681f4912&scoped=true"
import script from "./PLUD.vue?vue&type=script&lang=js"
export * from "./PLUD.vue?vue&type=script&lang=js"
import style0 from "./PLUD.vue?vue&type=style&index=0&id=681f4912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f4912",
  null
  
)

export default component.exports